import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveConditionDeviceStateInfo,
  saveMultilevelSensorValueDescription,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultilevelSensorValue
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/MultilevelSensorCondition/SelectMultilevelSensorValue/SelectMultilevelSensorValue'
import SelectMultilevelSensorValueIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/MultilevelSensorCondition/SelectMultilevelSensorValue/SelectMultilevelSensorValue'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRouter,
} from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMultilevelSensorValueIOS) : withStyles(SelectMultilevelSensorValue)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { conditionDeviceNumber, sensorType, sensorScales } = state.scenes.currentSceneCreating.currentCondition
  const { isChangeSensorStateMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    conditionDeviceNumber,
    sensorType,
    isChangeSensorStateMode,
    sensorScales,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionDeviceStateInfo,
  saveMultilevelSensorValueDescription,
}, dispatch)

enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultilevelSensorValueEnhanced = enhance

export default withRouter(SelectMultilevelSensorValueEnhanced)
